import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content d-flex flex-column transition overflow-hidden p-0" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppLogo = _resolveComponent("AppLogo")!
  const _component_InvitationForm = _resolveComponent("InvitationForm")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppLogo, { variant: "prelogin" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_InvitationForm)
      ])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}